export default {
  en: {    
    settings: {
         account: {
            'lead' :  'ACCOUNT',
            "examples": [
                'Vengo always sends you an e-mail with the invoice of your shipment after it has been delivered by the driver.',
                'Unfortunately, you can not drop this off because Vengo does not perform billing by mail.',
                'You will always receive an e-mail and a push notification when there are changes made to you profile.'                
            ]
        },
        push: 'Push notification',
        mail: 'E-mail',
        messages: {
            'lead' : 'MESSAGES',
            'examples' : [
                'Do you want to be notified when a driver / sender sends you a message?',
            ]
        },
        ratings: {
            'lead' : 'RATINGS',
            'examples' : [
                'Do you want to know what a driver / sender thought of you?',
            ]
        },
        sendershipments: {
            'lead' : 'AS SENDER',
            'examples': [
                'Do you want to know when you received a new offer on your shipment?',
                'Do you want to be informed about the status of your shipment and the location of the driver?.'
            ]
        },

        drivershipments: {
            'lead' : 'ALS DRIVER',
            'examples': [
                'Keep me updated about new shipments in my neighborhood.',
                'Let me now when my bid was accepted by the sender',
                'Send me an overview of my offers and their current status each week at the end of the week.'
            ]}
        }
  },

  nl: {    
  	settings: {
        account: {
            'lead' :  'ACCOUNT',
            "examples": [
                'Vengo stuurt je altijd een e-mail met de factuur van je zending nadat deze is geleverd door de chauffeur.',
                'Dit kan je helaas niet afzetten omdat Vengo geen facturatie per post uitvoert.',
                'Ook krijg je altijd een e-mail en een pushnotificatie op je smartphone wanneer er wijzigingen aan je profiel zijn.'                
            ]
        },
        push: 'Pushbericht',
        mail: 'E-mail',
        messages: {
            'lead' : 'BERICHTEN',
            'examples' : [
                'Wil je verwittigd worden wanneer een chauffeur / verzender je een bericht stuurt?',
            ]
        },
        ratings: {
            'lead' : 'BEOORDELINGEN',
            'examples' : [
                'Wil je weten wat een chauffeur / verzender van je vond?',
            ]
        },
        sendershipments: {
            'lead' : 'ALS VERZENDER',
            'examples': [
                'Wil je weten wanneer er een nieuw bod op je zending is?',
                'Wil je op de hoogte gehouden worden over de status van je zending en de positie van de chauffeur.'
            ]
        },

        drivershipments: {
            'lead' : 'ALS CHAUFFEUR',
            'examples': [
                'Hou mij op de hoogte over nieuwe zendingen in mijn buurt.',
                'Laat mij weten wanneer mijn bod werd aanvaard door de verzender.',
                'Stuur me elke week, aan het einde van de week, een overzicht van mijn boden en hun huidige status.'
            ]

        }
    }  	  	  	
  },
  fr: {    
    settings: {
         account: {
            'lead' :  'COMPTE',
            "examples": [
                'Vengo vous envoie toujours un e-mail avec la facture de votre envoi après sa livraison par le chauffeur.',
                'Malheureusement, vous ne pouvez pas déposer ceci car Vengo n\'effectue pas la facturation par courrier.',
                'Vous recevrez toujours un e-mail et un notification push sur votre smartphone en cas de modification de votre profil.'                
            ]
        },
        push: 'Notification push',
        mail: 'E-mail',
        messages: {
            'lead' : 'MESSAGES',
            'examples' : [
                'VOulez-vous être averti lorsqu\'un chauffeur / expéditeur vous envoie un message?',
            ]
        },
        ratings: {
            'lead' : 'évaluations',
            'examples' : [
                'Voulez-vous savoir ce qu\'un chauffeur / expéditeur a trouvé de vous?',
            ]
        },
        sendershipments: {
            'lead' : 'COMME EXPEDITEUR',
            'examples': [
                'Voulez-vous savoir quand il y a une nouvelle offre sur votre envoi?',
                'Souhaitez-vous être tenu informé de l\'état de votre envoi et de la position du chauffeur?.'
            ]
        },

        drivershipments: {
            'lead' : 'COMME CHAUFFEUR',
            'examples': [
                'Tenez-moi au courant des nouveaux envois dans mon environment.',
                'Laissez-moi savoir quand mon offre a été accepté par l\'expéditeur.',
                'Envoyez-moi un aperçu de mes offre et leur statut actuel chaque semaine à la fin de la semaine.'
            ]

            }
        }
    }           
  }

